import {createAsyncThunk} from "@reduxjs/toolkit";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import axios from "axios";

import {createRequestParams} from "common/hook/create-request-params/createRequestParams";
import {LessonTestApiResponse} from "features/model/types/lessons/lessons-test/lessonsTest";
import {setLessonsTest} from "features/model/slice/lessons/lessons-test/lessonsTest";


interface Params {
    from?: string;
    to?: string;
    page?: number;
    lessonsId?:string | undefined;
}


export const getLessonsTest = createAsyncThunk(
    "lessons/test",
    async ({from, to, page,lessonsId}: Params, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);

            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const {token} = JSON.parse(authToken);

            const params = createRequestParams(from, to, page);

            const response = await axios.get<LessonTestApiResponse>(`/api/lessons/${lessonsId}/tests`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params,
                }
            );

            if (response.data && response.data.success) {
                thunkAPI.dispatch(setLessonsTest(response.data.data))
            }

            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);
